var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group"},_vm._l((_vm.sorts),function(item){return _c('sort',{key:item.name,ref:item.name,refInFor:true,class:_vm.sortClass,attrs:{"label":item.label,"name":item.name,"initStatus":item.initStatus},on:{"onChange":_vm.sortChange}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }